<template>
    <div class="user">
        <!-- 头 -->
        <navbar-header></navbar-header>
        <!-- 用户信息 -->
        <user-info :userInfo="userInfo" :rankInfo="rankInfo"></user-info>
        <!-- 信息form -->
        <info-form></info-form>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import NavbarHeader from "@/components/user/NavbarHeader"
    import UserInfo from "@/components/user/UserInfo"
    import InfoForm from "@/components/user/InfoForm"
    export default {
        components: {
            NavbarHeader,
            UserInfo,
            InfoForm,
        },
        data() {
            return {
                userInfo: {},
                rankInfo: {}
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted () {
            this.getUserInfo();
            this.getRank()
        },
        methods: {
            // 获取个人信息
            async getUserInfo () {
                let res = await this.$axios.post("/lencon/pc/person/member_info", { token: this.token })
                if ( res.data.code == 1 ) {
                    this.userInfo = res.data.obj

                }
            },
            // 获取积分排名
            async getRank () {
                let res = await this.$axios.post("/lencon/pc/person/myRank", { token: this.token  })
                if ( res.data.code == 1 ) {
                    this.rankInfo = res.data.obj
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.user {
    width: 100%;
    height: 100%;
    background: url("../assets/static/zhibu/my_bg.jpg") 0 0 no-repeat;
}
</style>